import mock from './mock';
import './db/faq-db';

mock.onAny().passThrough();
